/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

// Brand colors
const upduoBrandBrightBlue = "#87DCFA";
const upduoBrandBlue = "#8FA5FF";
const upduoBrandPurple = "#BF97E5";
const upduoBrandOragne = "#FF9100";
const upduoBrandYellow = "#FFDD00";

// Main color scheme
const upduoPrimaryBlack = "#333333";
const upduoPrimaryDark = "#333C56";
const upduoPrimaryBlue = "#7091ED";
const upduoSecondaryOrange = "#F16D00";
const upduoSecondaryRed = "#EB5757";
const upduoSecondaryPurple = "#AA83DC";
const upduoSecondaryGreen = "#7DD67B";

// Grays
const upduoDarkGray = "#656C7F";
const upduoMediumDarkGray = "#858585";
const upduoMediumGray = "#929292";
const upduoMediumLightGray = "#A6A6A6";
const upduoLightGray = "#B0B0B0";
const upduoLighterGray = "#C4C4C4";
const upduoSecondLightestGray = "#E2E2E2";
const upduoLightestGray = "#EEEEEE";
const upduoBlueBackground = "#F1F4FE";

const upduoErrorBackground = "#F9CDCD";

// Special use colors (TODO change these to other colors)
const upduoOrangeSummitBackground = "#fbd3b3";
const upduoBlueSummitBackground = "#d4defa";
const upduoPurpleSummitBackground = "#e6daf5";
const upduoGraySummitBackground = "#e1e1e1";

const upduoSummitGradientOrange = "#F16D00";
const upduoSummitGradientBlue = "#7091ED";
const upduoSummitGradientPurple = "#AA83DC";
const upduoSummitGradientGray = "#969696";

const upduoKudosBlue = "#D5DEFA";
const upduoKudosPurple = "#E6DAF5";
const upduoKudosOrange = "#FBD4B3";
const upduoKudosCyan = "#DBF5FE";

const upduoSuccess = "#0BC01D";
const upduoFailure = "#FF5D5D";

// TODO add other button state colors from the new design library and rename this
const upduoBlueButtonHover = "#B8C8F6";

// Skale colors

const skalePrimaryBlue = "#4D7CFF"; // Spinner color
const skaleSecondaryBlue = "#4FA5FF"; // Top bar color
const skaleTextBlue = "#2F4057";
const skaleBlack = "#333C56"; // Pantone Black 6 C
const skaleBlue = "#307FE2"; // Pantone 2727 C
const skaleDarkGray = "#9EA2A2"; // Pantone 422 C
const skaleGray = "#C7C9C7"; // Pantone 420 C
const skaleLightBlue = "#59CBE8"; // Pantone 305 C
const skaleLightGray = "#D9D9D6"; // Pantone Cool Gray 1 C
const skaleLinkBlue = "#298FC2"; // Pantone 7689 C
const skaleMainBlue = "#1D428A"; // Pantone 7687 C
const skaleRed = "#FF585D"; // Pantone 178 C
const skaleLightRed = "#FF766B";
const skaleTeal = "#00C7B1"; // Pantone 3265 C
const skaleWhite = "#FDFDFD"; // Off-white (not Pantone)
const skaleBackgroundWhite = "#F0F0F0";
const skaleOffWhite = "#E5E5E5"; // Off-white (not Pantone)
const skaleYellow = "#FFC845"; // Pantone 1225 C
const skaleGreen = "#27AE60";
const skaleSoftRed = "#FF5E5E";
const skaleBackgroundBlue = "#E1F1FA";
const skaleTextButtonGray = "#6C6C6C";

const skaleWarningBackground = "#FFF8F1";
const skaleWarningText = "#FF7A00";

// Colors specific to upduo/web

const skaleWebBorderGray = "#BDBDBD";
const skaleWebFillGray = "#E0E0E0";
const skaleWebFillLightGray = "#F2F2F2";
const skaleWebFillStormy = "#AFB7C2";
const skaleWebTextGray = "#4F4F4F";
const skaleWebTextDarkGray = "#787878";
const skaleWebTextLightGray = "#828282";
const skaleWebBlueGray = "#617383";
const skaleWebBackgroundGray = "#EEEEEE";
const skaleWebBackgroundLightGray = "#BABABA";
const skaleWebTextBackgroundLightGray = "#FAFAFA";
const salesforceBlue = "#00A1E0";
const skalecalendarblue = "#047EFF";

// Colors for upduo/web cells
const skaleCellRed = "#FCE5CD";
const skaleCellYellow = "#FFF2CC";
const skaleCellGreen = "#C9DFC5";

// Colors borrowed from upduo/mobile
const skaleDeactiveGray = "#C4C4C4";
const skaleTextDarkGray = "#828282"; // Dark gray (not Pantone)
const skaleTextLightGray = "#ABABAB";
const skaleTextSecondaryGray = "#232323";
const skaleCircleGray = "#BDBDBD"; //circle gray border
const skaleCircleLightBlue = "#56CCF2"; //circle light blue current
const skaleOrange = "#FF7A00";
const skaleDarkBlue = "#2D9CDB"; //circle dark blue complete
const skaleDisabledButtonTextGray = "#777C83";
const skaleBackgroundGray = "#F2F2F2"; // Main background color
const skaleBackgroundGreen = "#39BF73";
const skaleBorderLightGray = "#E0E0E0"; // Light gray (not Pantone)
const skaleSummitDarkBlue = "#E0E8FC";
const skaleSummitDarkGray = "#515151";
const skaleTextGray = "#5C6263";
const skaleOverlayBlue = colorWithOpacity("#062048", 0.72);
const skaleGreenText = "#219653";
const upduoDarkGreen = "#55AB67";
const skaleCommunityGray = "#606163";
const skaleSkipGray = "#B0B0B0";
const buttonDisabledDefault = "#FDFDFD";
const buttonBlueAnimation = [
  skaleDarkBlue, // #2D9CDB
  "rgb(86, 204, 242)", // #56CCF2
  "rgb(51, 135, 237)", // #3387ED
  "rgb(47, 128, 237)", // #2F80ED skaleButtonBlue
];
const skaleModalTextGray = "#9A9A9A";
const skaleModalErrorRed = "#EB5757";
const upduoGraphColorSet = [
  "#87DCFA",
  "#8FA5FF",
  "#BF97E5",
  "#FF9100",
  "#FFDD00",
  "#7DD67B",
  "#F18989",
  "#4E66A6",
  "#775C9A",
  "#BC4646",
];

// Color utility functions

function colorWithOpacity(color, opacityValue) {
  let r, g, b;
  if (color.startsWith("rgb")) {
    const rgb_array = color.replace(/[^\d,]/g, "").split(",");
    r = rgb_array[0];
    g = rgb_array[1];
    b = rgb_array[2];
  } else {
    r = parseInt(color.substring(1, 3), 16);
    g = parseInt(color.substring(3, 5), 16);
    b = parseInt(color.substring(5, 7), 16);
  }
  const opacity = opacityValue ? opacityValue : 1;
  return `rgba(${r},${g},${b},${opacity})`;
}

export function colorWithLuminance(hex, lum) {
  // This function brightens (+)/ darkens(-) the hex color, and 0 returns original color
  // examples:
  // colorWithLuminance("#69c", 0);		// returns "#6699cc"
  // colorWithLuminance("6699CC", 0.2);	// "#7ab8f5" - 20% lighter
  // colorWithLuminance("69C", -0.5);	// "#334d66" - 50% darker
  // colorWithLuminance("000", 1);		// "#000000" - true black cannot be made lighter
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, "");
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  let rgb = "#",
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += `00${c}`.substr(c.length);
  }

  return rgb;
}

export {
  upduoBrandBrightBlue,
  upduoBrandBlue,
  upduoBrandPurple,
  upduoBrandOragne,
  upduoBrandYellow,
  upduoPrimaryBlack,
  upduoPrimaryDark,
  upduoPrimaryBlue,
  upduoSecondaryOrange,
  upduoSecondaryRed,
  upduoSecondaryPurple,
  upduoSecondaryGreen,
  upduoDarkGray,
  upduoMediumDarkGray,
  upduoMediumGray,
  upduoMediumLightGray,
  upduoLightGray,
  upduoLighterGray,
  upduoSecondLightestGray,
  upduoLightestGray,
  upduoBlueBackground,
  upduoErrorBackground,
  upduoOrangeSummitBackground,
  upduoBlueSummitBackground,
  upduoPurpleSummitBackground,
  upduoGraySummitBackground,
  upduoSummitGradientOrange,
  upduoSummitGradientBlue,
  upduoSummitGradientPurple,
  upduoSummitGradientGray,
  upduoKudosBlue,
  upduoKudosPurple,
  upduoKudosOrange,
  upduoKudosCyan,
  upduoSuccess,
  upduoFailure,
  upduoBlueButtonHover,
  upduoGraphColorSet,
  // Skale colors
  skalePrimaryBlue,
  skaleSecondaryBlue,
  skaleTextBlue,
  skaleBlack,
  skaleBlue,
  skaleDarkGray,
  skaleGray,
  skaleLightBlue,
  skaleLightGray,
  skaleLinkBlue,
  skaleMainBlue,
  skaleSoftRed,
  skaleBackgroundBlue,
  skaleRed,
  skaleLightRed,
  skaleTeal,
  skaleWhite,
  skaleBackgroundWhite,
  skaleOffWhite,
  skaleYellow,
  skaleGreen,
  skaleTextButtonGray,
  skaleWarningBackground,
  skaleWarningText,
  // Colors specific to upduo/web
  skaleWebBorderGray,
  skaleWebFillGray,
  skaleWebFillLightGray,
  skaleWebFillStormy,
  skaleWebTextGray,
  skaleWebBackgroundGray,
  skaleWebBackgroundLightGray,
  skaleWebTextDarkGray,
  skaleWebTextLightGray,
  skaleWebBlueGray,
  skaleWebTextBackgroundLightGray,
  salesforceBlue,
  skalecalendarblue,
  // Colors for upduo/web cells
  skaleCellRed,
  skaleCellYellow,
  skaleCellGreen,
  // Colors borrowed from upduo/mobile
  skaleDeactiveGray,
  skaleTextDarkGray,
  skaleTextLightGray,
  skaleTextSecondaryGray,
  skaleCircleGray,
  skaleCircleLightBlue,
  skaleOrange,
  skaleDarkBlue,
  skaleDisabledButtonTextGray,
  skaleBackgroundGray,
  skaleBorderLightGray,
  skaleBackgroundGreen,
  skaleSummitDarkBlue,
  skaleSummitDarkGray,
  skaleTextGray,
  skaleOverlayBlue,
  skaleGreenText,
  upduoDarkGreen,
  skaleCommunityGray,
  skaleSkipGray,
  buttonDisabledDefault,
  buttonBlueAnimation,
  skaleModalTextGray,
  skaleModalErrorRed,
  // Color utility functions
  colorWithOpacity,
};
